// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__uEQw2","actionsCol":"EnrolledClinics_actionsCol__2ykDo"};